/*
 * Multi-conta — interruptor do recurso.
 *
 * A flag mora no `public/index.html` (`window.__MULTICONTA_ATIVO__`), e não aqui, porque
 * o `session-shim.js` precisa dela ANTES do bundle do React carregar. Manter um único
 * ponto de verdade evita o front pensar que o recurso está ligado enquanto o shim está
 * desligado — o que deixaria duas contas compartilhando o mesmo localStorage.
 *
 * Para ligar/desligar: `public/index.html`, uma linha.
 *
 * Desligado, o efeito é: sem botão na topbar, sem a rota /contas e sem isolamento de
 * storage. O CRM se comporta exatamente como antes do recurso existir.
 */
export function multicontaAtivo(): boolean {
  try {
    return (window as any).__MULTICONTA_ATIVO__ === true;
  } catch {
    return false;
  }
}

/** true quando esta página está rodando DENTRO de um frame de conta. */
export function dentroDeFrameDeConta(): boolean {
  try {
    return !!(window as any).__CRM_SID__;
  } catch {
    return false;
  }
}
